import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState, Suspense, useTransition } from 'react';
import { API_URL } from '../../../config/constants';
import './Monitoring.scss';
import CustomLineChart from '../../components/CustomLineChart';
import { CSVLink } from 'react-csv';
import DataListMenu from './DataListMenu';
import MonitTable from './MonitTable';
import csvSaveIcon from '../../../images/csvSave.png';
import { Scrollbars } from 'rc-scrollbars';
import { useBlocker, useNavigate, useOutletContext, useSearchParams } from 'react-router-dom';
import YouWereEditing from '../../components/YouWereEditing';
import editModeIcon from '../../../images/editDS.png';
import Loading from '../../components/Loading';
import NoData from '../../components/NoData';
import ChkDelModal from '../../components/ChkDelModal';
import { useSelector } from 'react-redux';

// const MonitTable = React.lazy(() => import('./MonitTable'));

function RealTimeMonitoring(props) {
    // 현재 로그인한 유저가 일반 사용자인지 여부
    const { login, privilege } = useSelector((state) => state.session);
    const navigate = useNavigate();

    // 공정 요약에서 '상세' 버튼으로 진입했을 경우 데이터 요청에 활용되는 쿼리스트링
    const [searchParams, setSearchParams] = useSearchParams();
    const qsSdsId = searchParams.get("sdsId");
    const qsSIdx = searchParams.get("sIdx");
    const qsDataId = searchParams.get("dataId");

    const [isPending, startTransition] = useTransition();

    // CSV 저장 시 파일 명으로 활용할 접두어
    const companyInitial = 'K';
    const sensorTypeInitial = 'D';
    // 추후 계정 정보에서 company 컬럼 데이터 받아오도록 수정要
    // company 정보를 기준으로 rawData 테이블을 선별해 받아옴
    const company = "세동산업";

    const [dataStructures, setDataStructures] = useState([]);   // 라디오 버튼 및 각종 세부 데이터 구조 관련 정보
    const [curPageData, setCurPageData] = useState({}); // 현재 세부데이터 영역에서 출력하고 있는 데이터

    const [lastId, setLastId] = useState(null); // getMoreData에서 불러올 세부데이터 시작점을 전달하기 위한 마지막 세부데이터 id
    const [noMoreData, setNoMoreData] = useState(false);    // 더이상 DB에 getMoreData로 불러올 과거 세부데이터가 없을 때 true

    const [dataList, setDataList] = useState([]);
    const [selSensorIdx, setSelSensorIdx] = useState(-1);   // 상단 라디오 버튼 선택 상태
    const [selDataIdx, setSelDataIdx] = useState(-1);   // 좌측 세부데이터 목록 선택 상태

    // 수정모드 관련 상태
    const [isEditMode, setIsEditMode] = useState(false);
    const [formData, setFormData] = useState([]);
    const [changed, setChanged] = useState(false);

    const [chkDelModalIsOpen, setChkDelModalIsOpen] = useState(false);  // 삭제 여부 재확인 팝업모달 출력 여부
    const [isLoading, setIsLoading] = useState(true);   //  API서버에서 데이터 요청 중일 때 대신 출력할 로딩 페이지 출력 여부
    const [pageData, setPageData] = useState(true);     // 페이지 데이터 없을 경우 로딩 페이지로 안넘어가고 NoData 페이지 출력 여부

    const [useQs, setUseQs] = useState(!!qsSdsId);

    async function getDds() {
        // 페이지가 처음 마운트될 때 데이터 구조 가져옴
        await axios.post(`${API_URL}/monitoring-manage/getMonitDataStructures`, { company: '세동산업', sdsId: qsSdsId, dataId: qsDataId }).then((res) => {
            const dataStructureArr = res.data["dataStructures"].filter(item => {
                const valView = item["valView"];
                return !(valView.filter(el => el === true).length === 0)
            });
            if (dataStructureArr.length === 0) {
                setIsLoading(false);
                setPageData(false);
                return;
            }
            if (dataStructureArr.length > 0) {
                if (qsSIdx) {
                    setSelSensorIdx(parseInt(qsSIdx));
                } else {
                    setSelSensorIdx(0);
                }
                setDataStructures(dataStructureArr)
            }
        })
    }

    async function getInitMonit() {
        // 해당하는 라디오 버튼에 대한 세부 데이터 요청 
        await axios.post(`${API_URL}/monitoring-manage/getInitMonit`, { company: '세동산업', sdsId: useQs ? qsSdsId : null, sIdx: useQs ? qsSIdx : null, dataId: useQs ? qsDataId : null, dataStructures: dataStructures, selSensorIdx: selSensorIdx }).then((res) => {

            const resInitData = res.data;
            const lastMdId = resInitData["datas"]["monitData"].length > 0 ? resInitData["datas"]["monitData"][resInitData["datas"]["monitData"].length - 1].dataId : -1;
            if (resInitData["selectedInfo"] === undefined) {
                if (resInitData["datas"].monitData.length > 0) startTransition(() => setSelDataIdx(0));
                setLastId(prev => lastMdId);
                setDataList(prev => [...resInitData["datas"]["monitData"]]);
                setNoMoreData(resInitData["datas"].end);
                setIsLoading(false)
            } else {
                setSelSensorIdx(parseInt(qsSIdx));
                setSelDataIdx(resInitData["selectedInfo"]["selectedDataIdx"]);
                setDataList(prev => [...resInitData["datas"]["monitData"]]);
                setLastId(prev => resInitData["datas"]["monitData"][resInitData["datas"]["monitData"].length - 1].dataId);
                setNoMoreData(resInitData["datas"].end);
                setIsLoading(false)
            }

        });
    }

    async function getMonitData() {
        console.log('getMonitData')
        await axios.post(`${API_URL}/monitoring-manage/getMonitData`, { dDsId: dataStructures[selSensorIdx]["dDsId"], dataId: dataList[selDataIdx]["dataId"] }).then(res => {
            const { data } = res;
            const dsData = dataStructures[selSensorIdx];
            const monData = data.monitData;
            if (monData === null) {
                setCurPageData({});
            }
            // const convMonData = monData.map(mon => {
            //     const dataStr = mon.data; // '...; 0.0, 0.0221; 0.1, 0.2311;' 형태의 센서 데이터
            //     const dataArr = dataStr.split(';');
            //     dataArr.pop();
            //     const arrayConvertedDataArr = dataArr.map(el => el.split(','));
            //     return ({ ...mon, data: arrayConvertedDataArr })
            // });
            console.log(data)
            const dataStr = monData.data; // '...; 0.0, 0.0221; 0.1, 0.2311;' 형태의 센서 데이터
            const dataArr = dataStr.split(';');
            dataArr.pop();
            const arrayConvertedDataArr = dataArr.map(el => el.split(','));
            const convMonData = {
                ...monData,
                data: arrayConvertedDataArr
            }
            const grpNameArr = dsData.indexName;
            const dimensionArr = dsData.indexDim;
            const sumDsId = dsData.sumDsId;
            const dataObj = {
                ...data,
                dataStructure: dsData,
                monitData: convMonData,
                rawNo: dsData.rawNo,
                indexName: grpNameArr,
                dimension: dimensionArr,
                sumDataId: sumDsId,
            };

            setCurPageData(prev => dataObj);
        }).catch(err => console.error(err));
    }

    // 라디오 버튼 선택 이벤트
    const onChangeSensorType = (e) => {
        e.preventDefault();
        console.log('타입 변경')
        const wdIdx = parseInt(e.target.value);
        setUseQs(false);
        setSelSensorIdx(wdIdx);
        setSelDataIdx(-1);
    };


    // 세부데이터 삭제 버튼 이벤트
    const onDeleteData = async (e) => {
        e.preventDefault();
        const tableName = dataStructures[selSensorIdx]["tableName"];
        const dataId = curPageData["monitData"]["dataId"];
        await axios.post(`${API_URL}/monitoring-manage/deleteMonit`, { setName: tableName, dataId: dataId, noIndex: selSensorIdx, sumDsId: curPageData["dataStructure"]["sumDsId"] }).then(res => {
            const { success } = res.data;
            if (success) {
                if (dataList.length - 1 === 0) {
                    const copiedCPMDArr = [...dataList];
                    const modifiedCPD = copiedCPMDArr.filter(el => el.dataId !== dataId)
                    setDataList(modifiedCPD);
                    setSelDataIdx(-1);
                    setChkDelModalIsOpen(false);
                } else if (selDataIdx === curPageData["monitData"].length - 1) {
                    const copiedCPMDArr = [...dataList];
                    const modifiedCPD = copiedCPMDArr.filter(el => el.dataId !== dataId)
                    setDataList(modifiedCPD);
                    setSelDataIdx(prev => prev - 1);
                    setChkDelModalIsOpen(false);
                } else if (selDataIdx === 0) {
                    const copiedCPMDArr = [...dataList];
                    const modifiedCPD = copiedCPMDArr.filter(el => el.dataId !== dataId)
                    setDataList(modifiedCPD);
                    setSelDataIdx(-1);
                    setChkDelModalIsOpen(false);
                    setTimeout(() => {
                        setSelDataIdx(0);
                    }, 0);
                } else {
                    const copiedCPMDArr = [...dataList];
                    const modifiedCPD = copiedCPMDArr.filter(el => el.dataId !== dataId)
                    setDataList(modifiedCPD);
                    setSelDataIdx(prev => prev + 1);
                    setChkDelModalIsOpen(false);
                }
            } else {
                // 시도가 성공하지 않음을 알림
            }
        }).catch(err => console.error(err));
    }
    // 수정모드에서 각 input의 onChange 이벤트
    const onChangeInput = (e, index, key) => {
        const copiedArr = [...formData];
        copiedArr[index][key] = parseFloat(e.target.value);
        setFormData([...copiedArr]);
        setChanged(true);
    }

    // 최신 데이터 
    const getPrevData = async e => {
        try {
            const res = await axios.post(`${API_URL}/monitoring-manage/getPrevMonit`, {
                headId: dataList[0].dataId, company, isAbout: dataStructures[selSensorIdx]["tableName"]
            });
            const monitDatas = res.data.monitData;
            if (monitDatas.length > 0) {
                setDataList(prev => [...monitDatas, ...prev]);
                setNoMoreData(prev => res.data.end ?? prev);
            }
        } catch (err) {
            console.error(err)
        }
    }

    const getData = useCallback(async (isAbout) => {
        console.log('겟 데이터 실행')
        try {
            const res = await axios.post(`${API_URL}/monitoring-manage/getMonit`, { lastId: lastId, company: company, isAbout: isAbout });
            const monitDatas = res.data.monitData;
            setDataList(prev => [...prev, ...monitDatas])
            setLastId(monitDatas[monitDatas.length - 1].dataId);
            setNoMoreData(res.data.end);

            console.log('실행 완료')
        } catch (e) {
            console.error(e);
        }
    }, [lastId, curPageData]);

    // 수정 버튼 이벤트
    const onSubmitEdit = async e => {
        e.preventDefault();
        const selData = { ...curPageData["monitData"] };
        // formData에 상태관리 중이던 값들을 변환, NaN 오류 방지
        const sortedFormData = formData.map(item => {
            const retArr = [];
            const convTime = Object.is(parseFloat(item.time), NaN) ? 0.0 : Number.isInteger(parseFloat(item.time)) ? parseFloat(item.time).toFixed(1) : parseFloat(item.time);
            const convData1 = Object.is(parseFloat(item.data1), NaN) ? 0.0 : Number.isInteger(parseFloat(item.data1)) ? parseFloat(item.data1).toFixed(1) : parseFloat(item.data1);
            retArr.push(convTime);
            retArr.push(convData1);
            if (item.data2) {
                const convData2 = Object.is(parseFloat(item.data2), NaN) ? 0.0 : Number.isInteger(parseFloat(item.data2)) ? parseFloat(item.data2).toFixed(1) : parseFloat(item.data2);
                retArr.push(convData2);
            }
            return retArr;
        });

        // 'time' 열을 기준으로 오름차순 정렬
        sortedFormData.sort((a, b) => parseFloat(a[0]) - parseFloat(b[0]));

        let csvStr = '';
        for (const item of sortedFormData) {
            const dataStr = `${item[0]},${item[1]}${item[2] ? (',' + item[2]) : ''};`
            csvStr = csvStr + dataStr;
        };
        const reqData = {
            data: csvStr,
        }



        await axios.post(`${API_URL}/monitoring-manage/updateMonit`, { data: reqData, dataId: selData.dataId, isAbout: dataStructures[selSensorIdx]["tableName"], }).then(res => {
            const { success, data } = res.data;
            if (success) {
                updateOneData(data);
            } else {
                console.log(res.data.error);
                window.alert('업데이트에 실패했습니다. 잠시 후 다시 시도해 주세요.');
            }
        }).catch(err => { console.error(err) })

    };

    // 취소 버튼 이벤트
    const onReset = e => {
        const selData = { ...curPageData["monitData"] };
        setFormData(selData.data.map((el, idx) => {
            const retObj = { "id": idx };
            for (let i = 0; i < el.length; i++) {
                if (i === 0) {
                    retObj["time"] = parseFloat(el[i]);
                } else {
                    retObj[`data${i}`] = parseFloat(el[i]);
                };
            };
            return (retObj);
        }));
        setChanged(false);
        setIsEditMode(false);
    };
    const updateOneData = (propData) => {
        const { updatedData, dataStructure } = propData;
        const { dataId, data } = updatedData;
        const monitData = [...curPageData['monitData']];
        const dataIdx = monitData.findIndex(obj => obj.dataId === dataId);
        const dataArr = data.split(';');
        dataArr.pop();
        const arrayConvertedDataArr = dataArr.map(el => el.split(','));

        const convertedData = {
            ...updatedData, data: arrayConvertedDataArr,
        };
    }

    // CSV 저장 시도 시 CSV 형태로 변환하는 함수
    function makeCsvData() {
        if (Object.keys(curPageData).length > 0) {
            const selData = { ...curPageData["monitData"] };
            const grpNamesStr = dataStructures[selSensorIdx].indexName;
            const labelArr = ["time", ...grpNamesStr];
            const dataArr = selData.data;
            const mergedArr = [labelArr, ...dataArr];
            return mergedArr;
        }
    }

    const handleDownloadCsv = () => {
        const csvData = makeCsvData();

        if (!csvData || csvData.length === 0) {
            alert("저장할 데이터가 없습니다.");
            return;
        }

        const csvRows = csvData.map(row => row.join(',')).join('\n');
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csvRows], { type: 'text/csv;charset=utf-8;' });

        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.href = url;

        const filename = `${companyInitial}${sensorTypeInitial}${curPageData["monitData"]["date"]}.csv`;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);  // 메모리 해제
    };


    // 공정 요약 → 버튼 클릭 이벤트
    const onClickChkSumData = e => {
        e.preventDefault();
        navigate(`/home/data/sumData/detail?sumDsId=${curPageData["dataStructure"]["sumDsId"]}&dataId=${curPageData["monitData"]["sumDataId"]}`);
    };

    // selData에 변동이 있으면 input에 각 데이터를 배치
    useEffect(() => {
        // setTableLoading(true);
        const selData = Object.keys(curPageData).length > 0 && selDataIdx !== -1 ? { ...curPageData["monitData"] } : null;
        const convData = selData ? selData.data.map((el, idx) => {
            const retObj = { "id": idx };
            for (let i = 0; i < el.length; i++) {
                if (i === 0) {
                    retObj["time"] = parseFloat(el[i]);
                } else {
                    retObj[`data${i}`] = parseFloat(el[i]);
                };
            };
            return (retObj);
        }) : [];
        setFormData([...convData]);
    }, [curPageData, selSensorIdx, selDataIdx]);
    // 수정 도중 페이지를 전환할 때 재확인
    const [blockPopup, setBlockPopup] = useState(false);    // 수정 중임을 알리는 재확인 팝업 출력 여부
    let blocker = useBlocker(({ currentLocation, nextLocation }) =>
        changed && login &&  // 수정 상태이고
        currentLocation.pathname !== nextLocation.pathname);    // 이동하려는 pathname이 현재와 다를 때
    useEffect(() => {
        if (blocker.state === "blocked") {  // blocker가 발동하면
            setBlockPopup(true);    //팝업 출력
        } else {
            setBlockPopup(false);
        }
    }, [blocker.state]);


    // 페이지가 처음 마운트될 때 getDds() 실행
    useEffect(() => {
        const initMonit = async () => {
            await getDds();
        };
        initMonit();
    }, []);

    async function updateSelSensorIdx() {
        if (selSensorIdx >= 0) {
            setDataList([]);
            setSelDataIdx(-1);
            await getInitMonit();
        }
    }
    useEffect(() => {
        updateSelSensorIdx();
    }, [selSensorIdx]); // selSensorIdx가 변경될 때 실행

    useEffect(() => {
        if (selDataIdx >= 0) {
            getMonitData();
        }
    }, [selSensorIdx, selDataIdx])
    return (
        pageData === false ? <NoData /> :
            isLoading ? <Loading /> :
                <React.Fragment>
                    <div className='monitoringPage'>
                        <p className='path'>데이터 관리<span className='below'>{'>'}</span>세부 데이터</p>
                        <h2 className='pageTitle'>세부 데이터</h2>
                        <div className='btnsArea'>
                            <Scrollbars style={{ width: '100%' }} >
                                <div className='scrollArea' style={{ minWidth: `${200 * dataStructures.length}px` }}>
                                    {
                                        dataStructures.map((item, idx, arr) => {
                                            const valView = item["valView"];
                                            if (valView.filter(el => el === true).length === 0) {
                                                return null;
                                            } else {
                                                return (
                                                    <div className='sensorOnOffArea' key={idx}>
                                                        <p>
                                                            <input className='sensorTypeRadio' type='radio' name='sensorType' id={item.tableName} value={idx} onChange={onChangeSensorType} checked={selSensorIdx === idx} />
                                                            <label htmlFor={item.tableName} className='sensorTitle'><span className={selSensorIdx === idx ? 'radioVisual on' : 'radioVisual off'} />{item.tableName}</label>
                                                        </p>
                                                    </div>
                                                );
                                            }
                                        })
                                    }
                                </div>
                            </Scrollbars>
                        </div>
                        <div className='monitArea'>
                            {/* 좌측 데이터 목록 컴포넌트 */}
                            <DataListMenu
                                monitData={selSensorIdx >= 0 ? dataList : []}
                                selSensorIdx={selSensorIdx}
                                selDataIdx={selDataIdx}
                                setSelDataIdx={setSelDataIdx}
                                getPrevData={e => {
                                    e.preventDefault();
                                    console.log('이전 데이터 추가');
                                    getPrevData(e);
                                }}
                                getMoreData={e => {
                                    e.preventDefault();
                                    console.log('새 데이터 추가');
                                    getData(dataStructures[selSensorIdx]["tableName"]);
                                }}
                                isLastData={noMoreData}
                            />
                            <div className='monitPrintArea'>
                                {
                                    // selDataIdx === -1 ? null :
                                    Object.keys(curPageData).length > 0 ?
                                        <div className='monitContainer'>
                                            <div className='monitTblDiv'>
                                                <div className='monitTblTop'>
                                                    <div className='sumDataInfoDiv'>
                                                        <SumDataInfo curPageMonitData={curPageData["monitData"]} sumDsId={Object.keys(curPageData).length > 0 ? curPageData["dataStructure"]["sumDsId"] : -1} />
                                                        <button className='toSumData' onClick={onClickChkSumData} >
                                                            <span>공정 요약</span>
                                                            <span className='icon'>
                                                                →
                                                            </span>
                                                        </button>
                                                    </div>
                                                    <div className='btnsArea'>
                                                        <div className={!isEditMode ? 'viewModeBtnsArea visible' : 'viewModeBtnsArea invisible'}>
                                                         
                                                            <button className='saveCSVBtn' onClick={handleDownloadCsv}>
                                                                <img src={csvSaveIcon} alt='csv 저장' />
                                                                <span>CSV 저장</span>
                                                            </button>

                                                            <button className='deleteDataBtn' onClick={e => { e.preventDefault(); setChkDelModalIsOpen(true); }} disabled={!privilege?.detailedData.delete}>
                                                                데이터 삭제
                                                            </button>
                                                            <button className={isEditMode ? 'editBtn editModeBtn activated' : 'editBtn editModeBtn deactivated'} onClick={e => {
                                                                e.preventDefault();
                                                                setIsEditMode(!isEditMode);
                                                            }} disabled={!privilege?.detailedData.edit}><img src={editModeIcon} /></button>
                                                        </div>
                                                        <div className={isEditMode ? 'editModeBtnsArea visible' : 'editModeBtnsArea invisible'}>
                                                            <button className='editBtn' onClick={onSubmitEdit} disabled={!changed}>저장</button>
                                                            <button className='cancelBtn' onClick={onReset} >취소</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='monitTblArea'>
                                                    <MonitTable dataStructures={dataStructures} selSensorIdx={selSensorIdx} selDataIdx={selDataIdx} formData={formData} onChangeInput={onChangeInput} isEditMode={isEditMode}
                                                    // loading={tableLoading} setLoading={setTableLoading}
                                                    />
                                                </div>
                                            </div>
                                            <div className='chartArea'>
                                                <div className='lineChartArea'>
                                                    <CustomLineChart
                                                        data={formData}
                                                        dsData={curPageData.dataStructure}
                                                    />
                                                    <ChartInfo data={{ ...curPageData["monitData"], data: formData }} dataStructure={curPageData.dataStructure} />
                                                    <div className='legendDiv'>
                                                        {
                                                            curPageData.dataStructure.indexName.map((idxName, idx) => {
                                                                if (curPageData.dataStructure.valView[idx]) {
                                                                    return (
                                                                        <div className='legend' key={`legend_${idx}`}>
                                                                            <div className='stroke' style={{ backgroundColor: idx === 0 ? '#0A2B83' : '#45BFCE' }} />
                                                                            <p>{idxName}</p>
                                                                        </div>
                                                                    )
                                                                }
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : null
                                }
                            </div>

                        </div>
                    </div>
                    <YouWereEditing
                        isOpen={blockPopup}
                        onRequestClose={e => { e.preventDefault(); blocker.reset(); }}
                        onSubmit={e => { e.preventDefault(); blocker.proceed(); }}
                    />
                    <ChkDelModal
                        isOpen={chkDelModalIsOpen}
                        onRequestClose={() => setChkDelModalIsOpen(false)}
                        onSubmit={onDeleteData}
                    />
                </React.Fragment>
    );
}

function SumDataInfo({ curPageMonitData, sumDsId }) {
    const [data, setData] = useState(null);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await axios.post(`${API_URL}/monitoring-manage/getSumData`, { sumDsId: sumDsId, dataId: curPageMonitData["sumDataId"] });
                setData(response.data);
            } catch (err) {
                console.error(err);
            }
        }

        fetchData();
    }, [curPageMonitData, sumDsId]);

    if (!data) {
        return <div>로딩 중...</div>;
    }
    // 데이터 없으면 밑에 세 상수 null처리 
    if (data.data === null) {
        return (
            <div className='sumDataInfoArea'>
                <p>
                    <span>카운트 : </span>
                    <span>{curPageMonitData["serialNo"] ?? '　-　'}</span>
                </p>
                <p>
                    <span>차종 : </span>
                    <span>{'　-　'}</span>
                </p>
                <p>
                    <span>품명 : </span>
                    <span>{'　-　'}</span>
                </p>
                <p>
                    <span>품번 : </span>
                    <span>{'　-　'}</span>
                </p>
            </div>
        );
    } else {
        const { modelType, modelName, modelNo } = data.data.model;

        return (
            <div className='sumDataInfoArea'>
                <p>
                    <span>카운트 : </span>
                    <span>{curPageMonitData["serialNo"] ?? '　-　'}</span>
                </p>
                <p>
                    <span>차종 : </span>
                    <span>{modelType ?? '　-　'}</span>
                </p>
                <p>
                    <span>품명 : </span>
                    <span>{modelName ?? '　-　'}</span>
                </p>
                <p>
                    <span>품번 : </span>
                    <span>{modelNo ?? '　-　'}</span>
                </p>
            </div>
        );
    }

};

function ChartInfo({ data, dataStructure }) {
    const convertedData = data.data;
    const data1Arr = convertedData.map(el => parseFloat(el.data1));
    const data2Arr = convertedData.map(el => parseFloat(el.data2 ?? 0));
    const max1 = Math.max(...data1Arr);
    const max2 = Math.max(...data2Arr);
    const maxArr = [max1, max2];
    let parsedLabel = null;
    if (data.label) {
        if (typeof data.label === 'string') {
            try {
                parsedLabel = JSON.parse(data.label);
            } catch (e) {
                parsedLabel = data.label.split(/[|,]/).reduce((acc, pair) => {
                    const [key, rawValue] = pair.split(':');
                    if (key) acc[key] = rawValue;
                    return acc;
                }, {});
            }
        } else if (typeof data.label === 'object') {
            parsedLabel = data.label;
        }
    }
    const dateData = data.date;
    const year = parseInt(dateData.substr(0, 4));
    const month = parseInt(dateData.substr(4, 2));
    const date = parseInt(dateData.substr(6, 2));
    const hours = parseInt(dateData.substr(9, 2));
    const minutes = parseInt(dateData.substr(11, 2));
    const seconds = parseInt(dateData.substr(13, 2));
    const ampm = hours < 12 ? '오전' : '오후';

    if (parsedLabel) {
        const labelOrder = ["X", "Y", "좌", "우", "피크"];
        const labelEntries = labelOrder
            .filter(key => Object.prototype.hasOwnProperty.call(parsedLabel, key))
            .map(key => [key, parsedLabel[key]]);
        return (
            <div className='chartInfoArea'>
                <p>
                    <span>
                        {"생산 일시 : "}
                    </span>
                    <span>
                        {`${year}년 ${month}월 ${date}일 ${ampm} ${hours > 12 ? hours - 12 : hours}시 ${minutes}분 ${seconds}초`}
                    </span>
                </p>
                {
                    labelEntries.map(([key, value]) => {
                        const numericValue = Number(value);
                        const displayValue = Number.isFinite(numericValue)
                            ? numericValue.toFixed(2)
                            : (value ?? '-');
                        return (
                            <p key={`chartInfo_label_${key}`}>
                                <span>
                                    {`${key} : `}
                                </span>
                                <span>
                                    {displayValue}
                                </span>
                            </p>
                        );
                    })
                }
            </div>
        );
    }
    if (dataStructure.class !== "하중") {
        return (<div className='chartInfoArea'>
            <p>
                <span>
                    {"생산 일시 : "}
                </span>
                <span>
                    {`${year}년 ${month}월 ${date}일 ${ampm} ${hours > 12 ? hours - 12 : hours}시 ${minutes}분 ${seconds}초`}
                </span>
            </p>
            {
                dataStructure.indexName.map((idxName, idx) => {
                    if (dataStructure.valView[idx]) {
                        return (
                            <p key={`chartInfo_${idx}`}>
                                <span>
                                    {`${idxName} : `}
                                </span>
                                <span>
                                    {maxArr[idx].toFixed(2)}
                                </span>
                            </p>
                        );
                    }
                })
            }
            {/* <p>
                <span>
                    {`${dataStructure.indexName[0]} : `}
                </span>
                <span>
                    {max1.toFixed(2)}
                </span>
            </p>
            <p>
                <span>
                    {`${dataStructure.indexName[1]} : `}
                </span>
                <span>
                    {max2.toFixed(2)}
                </span>
            </p> */}
        </div>);
    } else {
        return (<div className='chartInfoArea'>
            <p>
                <span>
                    {"생산 일시 : "}
                </span>
                <span>
                    {`${year}년 ${month}월 ${date}일 ${ampm} ${hours > 12 ? hours - 12 : hours}시 ${minutes}분 ${seconds}초`}
                </span>
            </p>
            <p>
                <span>
                    {`${dataStructure.indexName[0]} : `}
                </span>
                <span>
                    {max1.toFixed(2)}
                </span>
            </p>
            {/* <p>
                <span>
                    {`이상패턴 : `}
                </span>
                <span>
                    {data["sumData"][`data_${}`] ?? '-'}
                </span>
            </p> */}
        </div>);
    }

}

export default RealTimeMonitoring;
